module.exports = __webpack_public_path__ + "img/6-ilpakamanioMASYmas.b0c11f2a.jpg";